module.exports = __webpack_public_path__ + "mobile hero.svg?23c648d4f869c07c7f7133bfc7abda37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/mobile hero.svg
// module id = 20
// module chunks = 0